import type { TFunction } from 'i18next';

/**
 * Zod messages in this module ARE i18n keys.
 *
 * Keeping the key in the schema means validation copy lives in the namespace with everything
 * else, and the schema stays free of React and of i18next. The typed-key checker cannot see that
 * a `string` coming out of a `FieldError` is a valid key, so the assertion is made once here
 * rather than being repeated — and quietly loosened — at every form field.
 */
export function translateValidationMessage(
  t: TFunction<'insurance'>,
  message: string | undefined,
): string {
  if (message === undefined || message === '') return '';
  return t(message as never);
}
